import {
  OrderPriceType,
  PreviewDeliveryOption,
} from '@global/utils/orderUtils';
import { OrderSummaryData } from './types';
import { LOCALE_CODES } from '@global/App/constants/location/constants';
import { buildPrice } from '@pages/checkout/helper';
import { getIsDeLocale } from '@src/global/utils/lang';

interface BuildOrderSummaryDataParams {
  language: LOCALE_CODES;
  orderPrice?: OrderPriceType;
  withTax: boolean;
  withShipping: boolean;
  deliveryOption?: PreviewDeliveryOption;
}

export function buildOrderSummaryData({
  orderPrice,
  withTax,
  withShipping,
  deliveryOption,
}: BuildOrderSummaryDataParams): OrderSummaryData {
  const isDe = getIsDeLocale();
  const discountPrice = buildPrice({
    ...orderPrice.price,
    value: orderPrice.discount.value,
  });
  const discount = orderPrice.discount.value ? '-' + discountPrice : '';

  return {
    productTotalPrice: buildPrice(isDe ? orderPrice.total : orderPrice.price),
    shipping: withShipping ? deliveryOption?.price : '',
    vat: '', // TODO: implement VAT logic: withTax ? buildPrice(getVatByPrice(orderPrice.price, vat)) : '', (OUT of scope)
    discount,
    tax: withTax
      ? buildPrice({ ...orderPrice.price, value: orderPrice.tax.value })
      : '',
    orderTotal: buildPrice(orderPrice.total),
  };
}
